module.exports = __webpack_public_path__ + "img/icon.5c31e9e1.png";